<div class="alert-dialog-outer">
	<h2 class="form-modal__title">{{ title }}</h2>
	<div class="form-modal__body">
		<p tabindex="1" aria-live="polite">{{ content }}</p>
	</div>
	<div class="form-modal__actions">
		<button class="btn btn-primary" (click)="dialogRef.close()">Ok</button>
	</div>
</div>
